/* unplugin-vue-components disabled */import script from "./loading.vue?vue&type=script&lang=ts&setup=true"
export * from "./loading.vue?vue&type=script&lang=ts&setup=true"

import "./loading.vue?vue&type=style&index=0&id=a7a95ac0&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/h5-activity-online-single/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7a95ac0"]])

export default __exports__